import React from 'react';
import { FOOTER_LINKS, SUPPORT_EMAIL } from '../data/config';
export function Footer() {
  return <footer className="bg-slate-950 px-4 py-6 text-center md:px-12" data-id="element-62" data-mp="3gfiugihumbe4">
      <p className="text-xs font-extrabold uppercase text-white" data-id="element-63" data-mp="32nulgo2wc31d">© 2026 Compra Digital Ya — Todos los derechos reservados.</p>
      <p className="mx-auto mt-2 max-w-2xl text-xs leading-normal text-white/70" data-id="element-64" data-mp="36oo87e4lrbso">
        COMBO COMPLETO ELECTRICISTAS proporciona materiales educativos y de consulta profesional. No sustituye la
        capacitación habilitante, la reglamentación AEA e IRAM aplicable, las instrucciones de fabricantes, las
        verificaciones reglamentarias ni los procedimientos de seguridad exigidos para trabajos eléctricos.
      </p>
      <p className="mx-auto mt-1.5 max-w-2xl text-xs leading-normal text-white/70" data-id="element-65" data-mp="3qc3z32pyhkhf">
        Los diagnósticos y mediciones de los ejemplos son simulados. Toda intervención sobre instalaciones reales debe
        realizarse por personal competente, conforme a los requisitos de seguridad y habilitación que correspondan.
      </p>
      <nav aria-label="Legal" className="mt-2 text-xs text-white" data-id="element-66" data-mp="3lbmuzun6vcgy">
        {FOOTER_LINKS.map((l, i) => <React.Fragment key={l.label} data-id="element-67" data-mp="3gctr8txpeztz" data-mpi={i}>
            {i > 0 && <span className="mx-1.5" aria-hidden data-id="element-68" data-mp="3v8rko4g8tq2i">•</span>}
            <a href={l.href} className="whitespace-nowrap transition-colors duration-150 hover:text-amber-400" data-id="element-69" data-mp="3q8n2m9zosna6">
              {l.label}
            </a>
          </React.Fragment>)}
      </nav>
      <p className="mt-1.5 text-xs text-white" data-id="element-70" data-mp="33xge4qruavo">
        Soporte:{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="underline transition-colors duration-150 hover:text-amber-400" data-id="element-71" data-mp="31uplihsodpw">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </footer>;
}